
import api from "~api";
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'

export default {
components: {
XHeader

},
data () {
return {
infoList: {},
}
},
created(){
this.getReportData()
},
mounted() {

},
methods: {
userInfo(){

},
getReportData(){
var reportParams = {
idCard:'1100000000000000000',
years:'2003',
payType:'0'
}
api.post( '/reportBill/QueryStuMessage',reportParams).then(res => {
console.log(res)
if(res.status == 200){
this.infoList = res.data.results;

}else{
this.$msgbox(res.data.errmsg);

}
}).catch( err =>{
this.$msgbox('温馨提示：',"系统错误！");
});
}

}
}



// WEBPACK FOOTER //
// ./src/components/report.vue